import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/app/(app)/gardens/[chain]/[garden]/[community]/[poolId]/page.tsx");
